<script setup lang="ts">
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'

defineProps({
	title: {
		type: String,
	},
	description: {
		type: String,
		required: true,
	},
	isSearch: {
		type: Boolean,
		default: false,
	},
})
</script>

<template>
	<div
		class="flex items-center justify-center py-[96px] text-center text-n-950 mdp:py-[48px] lg:py-[60px]"
	>
		<div
			class="flex w-[350px] flex-col items-center gap-24px mdp:gap-32px mdl:w-[342px] mdl:w-[470px] lg:w-[592px]"
		>
			<BaseIcon
				name="empty_of_post"
				class="inline-block h-[120px] w-[152px] mdp:h-[224px] mdp:w-[284px]"
			/>
			<div>
				<h3 v-if="!isSearch" class="typography-h4-str mb-12px">{{ title }}</h3>
				<p v-if="!isSearch" class="typography-b2-reg">
					{{ description }}
				</p>
				<p v-if="isSearch" class="typography-s1-emp whitespace-pre">
					{{ description }}
				</p>
			</div>
			<slot name="button" />
		</div>
	</div>
</template>
